import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FacebookBigIcon,
  InstagramBigIcon,
  SMSBigIcon,
  WhatsappBigIcon,
} from '../../../assets';
import { useAppData } from '../../../context/AppContext';
import { CampaignDataProps } from './startCampaignModels';
import { updateCampaign } from '../../../core/requests/requests';
import SelectPhoneNumbersModal from './SelectPhoneNumbersModal';
import { campaignViewValues } from '../../../config/CampaignsConfig';

const ChooseMediaView: React.FC = () => {
  useNavigate();
  const {
    setCurrentStartCampaignView,
    currentCampaign,
    setCurrentCampaign,
    setShowModalBackground,
  } = useAppData();
  const [showSelectPhoneNumberModal, setShowSelectPhoneNumberModal] =
    useState<boolean>(false);
  const currentCampaignId = currentCampaign?.id;

  const handleShowSelectPhoneNumberModal = () => {
    setShowModalBackground(true);
    setShowSelectPhoneNumberModal(true);
  };

  const handleCloseCreateModal = () => {
    setShowSelectPhoneNumberModal(false);
    setShowModalBackground(false);
  };

  const handleSelectPlatform = async (view: string) => {
    try {
      if (view && currentCampaignId) {
        const platformView = view === 'sms' ? 'SMS' : view;

        const campaignPayload: CampaignDataProps = {
          ...currentCampaign,
          platforms: [platformView],
        };
        const { data } = await updateCampaign(campaignPayload);
        if (data) {
          setCurrentCampaign(data);

          const isSmsPlatform = Array.isArray(data.platforms) && (data.platforms as string[]).includes('SMS');

          if (isSmsPlatform && !data.phoneId) {
            handleShowSelectPhoneNumberModal();
          } else {
            setCurrentStartCampaignView(campaignViewValues?.startCampaign);
          }
        }
      }
    } catch (error) {
      console.log('Error selecting platform', error);
      // Fallback for safety: only show modal if it's an SMS campaign
      if (view === 'sms') {
        handleShowSelectPhoneNumberModal();
      }
    }
  };

  return (
    <div className="d-flex-start-start w-100 mb-1_5rem ">
      <div className="d-flex-row w-100 b-1 b-radius-0_5rem shadow-box-3">
        <div
          className="d-flex-center w-25 h-14rem br-1 opacity-0_5"
        //onClick={() => handleViewChange('instagram')}
        >
          <div className="d-flex-center h-7_5rem w-7_5rem">
            <InstagramBigIcon />
          </div>
          <span className="text-inter-bold-1rem pt-1rem">Instagram</span>
        </div>
        <div
          className="d-flex-center w-25 h-14rem br-1 opacity-0_5"
        //onClick={() => handleViewChange('facebook')}
        >
          <div className="d-flex-center h-7_5rem w-7_5rem">
            <FacebookBigIcon />
          </div>
          <span className="text-inter-bold-1rem pt-1rem">Facebook</span>
        </div>
        <div
          className="d-flex-center w-25 h-14rem br-1 opacity-0_5"
        //onClick={() => handleViewChange('whatsapp')}
        >
          <div className="d-flex-center h-7_5rem w-7_5rem">
            <WhatsappBigIcon />
          </div>
          <span className="text-inter-bold-1rem pt-1rem">WhatsApp</span>
        </div>
        <div
          className="d-flex-center w-25 h-14rem hovered"
          onClick={() => handleSelectPlatform('sms')}
        >
          <div className="d-flex-center h-7_5rem w-7_5rem">
            <SMSBigIcon />
          </div>
          <span className="text-inter-bold-1rem pt-1rem">SMS</span>
        </div>
      </div>
      {showSelectPhoneNumberModal && (
        <SelectPhoneNumbersModal closeModal={handleCloseCreateModal} />
      )}
    </div>
  );
};

export default ChooseMediaView;
